import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';

import { SHARING_ORIGIN } from '#src/config.ts';
import { getPrefix } from '#src/lib/i18n.ts';
import {
  getHrefLangUrls,
  getLocalizedUrl,
} from '#src/lib/seo/localizedUrls.ts';

type Props = {
  /** Canonical of a page that duplicates another one: no hreflang then. */
  canonicalPathname?: string;
};

export const HrefLang = ({ canonicalPathname }: Props) => {
  const { pathname } = useLocation();
  const { locale } = useIntl();

  return (
    <Helmet>
      {canonicalPathname
        ? null
        : getHrefLangUrls(SHARING_ORIGIN, pathname).map(
            ({ hrefLang, href }) => (
              <link
                key={hrefLang}
                hrefLang={hrefLang}
                href={href}
                rel="alternate"
              />
            )
          )}
      <link
        href={getLocalizedUrl(
          SHARING_ORIGIN,
          getPrefix(locale),
          canonicalPathname ?? pathname
        )}
        rel="canonical"
      />
    </Helmet>
  );
};
